import { render, staticRenderFns } from "./TableAdsAccounts.vue?vue&type=template&id=18152574&scoped=true&"
import script from "./TableAdsAccounts.vue?vue&type=script&lang=js&"
export * from "./TableAdsAccounts.vue?vue&type=script&lang=js&"
import style0 from "./TableAdsAccounts.vue?vue&type=style&index=0&id=18152574&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18152574",
  null
  
)

export default component.exports